import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaRegEye } from "react-icons/fa";
import api from "../../../api/api";
import Swal from "sweetalert2";
import { useAuth } from "../../../context/AuthContext";
import LoadingSpinnerModal from "../../LoadingSpinnerModal";

const UnStartedTasks = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const params = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user && user.country) {
      api
        .get(
          `/api/User/GetRolesModulePermission?customerID=${user.country}&roleID=${user.role}&moduleID=14`
        )
        .then((res) => {
          // İlgili veriyi kontrol et
          if (
            res.data.assigmentID === undefined ||
            !res.data.reportPermission
          ) {
            // SweetAlert2 ile uyarıyı göster ve yönlendir
            Swal.fire({
              icon: "error",
              title: "Yetkiniz Yok",
              text: "Bu sayfaya yetkiniz yoktur.",
              confirmButtonText: "Tamam",
            }).then((result) => {
              if (result.isConfirmed) {
                // Yönlendirme işlemi
                navigate("/dashboards");
              }
            });
            return; // Diğer API çağrılarını atla
          }

          api
            .get(
              `/api/Project/GetUnstartedProjectTasks?customerID=${user.country}&projectID=${params.id}`
            )
            .then((res) => setData(res.data))
            .catch((err) => console.log(err.data))
            .finally(() => setLoading(false));
        })
        .catch((err) => console.log(err.data));
    }
  }, [user]);

  return (
    <>
      {loading ? (
        <LoadingSpinnerModal loading={loading} />
      ) : (
        <div className="relative overflow-x-auto w-full max-w-screen-2xl min-h-[400px]">
            <h1 className="text-xl font-medium text-blue-800 pb-4">Başlamayan Görevler ({data?.length})</h1>
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-white uppercase bg-[#050A27] sticky top-0">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Görev Adı
                </th>

                <th scope="col" className="px-6 py-3">
                  İşlemler
                </th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr key={index} className="bg-white border-b hover:bg-gray-50">
                  <th
                    scope="row"
                    className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                  >
                    {item?.name}
                  </th>
                  <td className="px-6 py-4">
                    <Link to={`../../taskDetailByAssignedUser/${item.taskID}`}>
                      <FaRegEye
                        size={20}
                        className="text-green-600 hover:underline"
                      />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default UnStartedTasks;
